import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { HELP_SECTIONS } from '../content/help';
import '../styles/HelpPage.css';

/**
 * Link renderer for the help markdown.
 *
 * Root-relative hrefs become router links so navigation stays in the app.
 * mailto links render as plain anchors. Anything else opens in a new tab.
 */
export function MarkdownLink({ href = '', children }) {
    if (href.startsWith('/')) {
        return <Link to={href}>{children}</Link>;
    }
    if (href.startsWith('mailto:') || href.startsWith('#')) {
        return <a href={href}>{children}</a>;
    }
    return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
}

const MARKDOWN_COMPONENTS = { a: MarkdownLink };

export default function HelpPage() {
    return (
        <div className="help-page">
            <header className="help-page-header">
                <div className="help-page-eyebrow">CensusZen</div>
                <h1 className="help-page-title">Help</h1>
                <p className="help-page-subtitle">How the intake workflow works, step by step, and how to reach us.</p>
            </header>

            <nav className="help-toc" aria-label="Help sections">
                <ol>
                    {HELP_SECTIONS.map((section) => (
                        <li key={section.id}>
                            <a href={`#${section.id}`}>{section.title}</a>
                        </li>
                    ))}
                </ol>
            </nav>

            {HELP_SECTIONS.map((section) => (
                <section key={section.id} id={section.id} className="help-section">
                    <h2 className="help-section-title">{section.title}</h2>
                    <div className="help-section-body">
                        <ReactMarkdown components={MARKDOWN_COMPONENTS}>{section.body}</ReactMarkdown>
                    </div>
                </section>
            ))}
        </div>
    );
}
